import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { useEffect, useState } from 'react';
import TokenxForm from '../TokenxForm/TokenxForm';
import { Field } from 'formik';
import { FormInput } from '../../../forms/elements';

function CreditCardForm(_ref) {
  var setFieldValue = _ref.setFieldValue,
      setGlobalState = _ref.setGlobalState,
      errors = _ref.errors,
      tokenxRef = _ref.tokenxRef,
      canShowZipError = _ref.canShowZipError,
      setCanShowZipError = _ref.setCanShowZipError;

  var handleTokenChange = function handleTokenChange() {
    var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setFieldValue('cardNumber', token.cardNumber);
    setFieldValue('expDate', token.expDate);
    setFieldValue('cvv', token.cvv);
    setGlobalState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        isValidCard: !!token.cardNumber,
        isValidExpiry: !!token.expDate,
        isValidCVV: !!token.cvv
      });
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TokenxForm, {
    ref: tokenxRef,
    onTokenChange: handleTokenChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "form-group form-group--zipcode"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "zipCode",
    label: "Zip Code",
    component: FormInput,
    className: "cb-form__input--full cb-form__input--zipcode",
    changeHandler: function changeHandler(e) {
      setFieldValue("billingZip", e);
      if (!canShowZipError) setCanShowZipError(true);
    }
  }), canShowZipError && !!errors.billingZip && /*#__PURE__*/React.createElement("div", {
    className: "tokenx-form__error"
  }, /*#__PURE__*/React.createElement("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 512 512",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm52.7 283.3L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3l52.7-52.7-52.7-52.7c-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3 6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6-6.2 6.3-16.4 6.3-22.6 0z"
  })), errors.billingZip)));
}

export default CreditCardForm;